import { Chip } from '@nextui-org/react'
import React, { FC, HTMLProps } from 'react'
import { SubmitTankType } from '../../types/apiResponse/tankTypes'

export type TankChipProps = {
  submitTank: SubmitTankType
  isActivated: boolean
  onTankChipClick: (tankId: string) => void
  disabled?: boolean
} & HTMLProps<HTMLDivElement>

export const TankChip: FC<TankChipProps> = ({
  submitTank,
  isActivated,
  onTankChipClick,
  disabled = false,
  ...props
}) => {
  return (
    <div {...props} data-testid={`selected-tank-chip-${submitTank.tankId}`}>
      <Chip
        radius="md"
        classNames={{
          base: `p-0 border-opacity-60 my-2 mx-[5px] ${
            isActivated
              ? 'bg-tdplplum border-tdplhibiscus border-[2px]'
              : submitTank.batchId === '$empty'
                ? 'bg-tdplsky border-tdpldarkgrey border-[1px]'
                : 'bg-tdpllightgrey border-tdpldarkgrey border-[1px]'
          }`,
          content: 'font-semibold fit-content text-[1rem]',
        }}
        onClick={() => !disabled && onTankChipClick(submitTank.tankId)}
        aria-disabled={disabled}
        style={{
          cursor: disabled ? 'not-allowed' : submitTank.batchId === '$empty' ? 'pointer' : 'default',
          opacity: disabled ? 0.5 : 1,
        }}
        data-testid={`tank-chip-${submitTank.tankId}`}
        data-tank-name={submitTank.tankName}
        data-tank-id={submitTank.tankId}
        data-batch-id={submitTank.batchId}
        data-activated={isActivated.toString()}
        aria-label={`Tank ${submitTank.tankName} ${isActivated ? 'selected' : 'not selected'}`}
        role="button"
      >
        {submitTank.tankName}
      </Chip>
    </div>
  )
}

export default TankChip
